import { Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';

import { CategoryTiles } from '../CategoryTiles/CategoryTiles';
import { CategoryRooms } from '../CategoryRooms/CategoryRooms';
import Error404Header from '../Error404Header/Error404Header';

const Error404LayoutComponent = ({ viewer }) => {
    return (
        <Fragment>
            <Error404Header />
            <CategoryTiles viewer={viewer} showModules />
            <CategoryRooms />
        </Fragment>
    );
};

Error404LayoutComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
};

export const Error404Layout = createFragmentContainer(Error404LayoutComponent, {
    viewer: graphql`
        fragment Error404Layout_viewer on Viewer {
            ...CategoryTiles_viewer
        }
    `,
});
